<div class="settings-title pt-3">
    <h1 translate="SETTINGS_TITLE"></h1>
    <div class="settings-title-description" translate="SETTINGS_TITLE_DESCRIPTION"></div>
</div>
<form [formGroup]="settingsForm">
    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="TIME_TO_GENERATE_ROUTES"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="TIME_TO_GENERATE_ROUTE_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-slider
                [min]="1"
                [max]="10"
                [step]="1"
                formControlName="solverRunTimeMinutes"
            ></app-slider>
        </div>
    </div>

    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="PARKING_TIME"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="PARKING_TIME_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-slider
                [min]="0"
                [max]="10"
                [step]="1"
                formControlName="parkingTimeMinutes"
            ></app-slider>
        </div>
    </div>

    @if (travelTimeDistanceBaselineFeature) {
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="TRAVEL_TIME_DISTANCE"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="TRAVEL_TIME_DISTANCE_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-optimization-settings-travel-time-distance-btn-group
                    formControlName="minimumTravelTimeDistanceMeters"
                ></app-optimization-settings-travel-time-distance-btn-group>
            </div>
        </div>
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="ADDITIONAL_TRAVEL_TIME"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="ADDITIONAL_TRAVEL_TIME_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-slider
                    [min]="0"
                    [max]="10"
                    [step]="1"
                    formControlName="minimumTravelTimeMinutes"
                ></app-slider>
            </div>
        </div>
    }
    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="SETTINGS_CLIENT_INCREASED_TRAVEL_TIME"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="INCREASED_TRAVEL_TIME_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-optimization-settings-travel-time-duration-btn-group
                formControlName="travelTimeAdjustmentProportion"
            ></app-optimization-settings-travel-time-duration-btn-group>
        </div>
    </div>

    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="SETTINGS_CLIENT_TASK_DURATION_ADJUSTMENT"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="TASK_DURATION_ADJUSTMENT_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-optimization-settings-tasks-duration-btn-group
                formControlName="patientTaskDurationAdjustmentProportion"
            ></app-optimization-settings-tasks-duration-btn-group>
            <app-dropdown
                class="dropdowns ml-4"
                placeholder="SELECT_SHIFTS"
                formControlName="shiftTypes"
                [items]="shiftTypes"
                [disable]="!shiftTypes"
                [multiple]="true"
            ></app-dropdown>
        </div>
    </div>

    @if (existHeavyTasks$ | async) {
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="SETTINGS_HEAVY_TASKS"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="HEAVY_TASK_CONFIG_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-optimization-settings-heavy-tasks-btn-group
                    formControlName="maximumNumberOfHeavyTasksPerEmployee"
                    [disable]="checkingHeavyTaskCapacityError"
                ></app-optimization-settings-heavy-tasks-btn-group>
            </div>
        </div>
    }

    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="SETTINGS_BALANCED_WORKLOAD"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="WORK_BALANCE_CONFIG_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-toggle id=useWorkBalance [large]="true" formControlName="useWorkBalance"
                        (change)="workBalanceChange()"></app-toggle>
        </div>
    </div>
    @if (showGroupTasksByPatientAndSkillRequirementFeature$ | async) {
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="SETTINGS_GROUP_TASKS_BY_PATIENT_AND_SKILL"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="GROUP_TASKS_BY_PATIENT_AND_SKILL_CONFIG_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-toggle id=useGroupTasksByPatientAndSkillRequirement [large]="true"
                            formControlName="useGroupTasksByPatientAndSkillRequirement"
                            (change)="groupTasksByPatientAndSkillRequirementChange()"></app-toggle>
            </div>
        </div>
    }
    @if (isRideSharingEnabledOnClient) {
        <div>
            <div class="setting-container row">
                <div class="col-md-3 setting-label">
                    <span translate="MAX_TRAVEL_TIME"></span>
                </div>
                <div class="col-md-9 setting-value">
                    <div class="d-flex setting-value">
                        <app-tooltip
                            class="ml-5 mr-3"
                            appCustomPopover
                            popoverText="DRIVE"
                            [compact]="true">
                            <ng-container icon>
                                <img
                                    src="/assets/images/icons/24_car.svg"
                                    alt="{{'DRIVE' | translate}}"
                                >
                            </ng-container>
                        </app-tooltip>
                        <app-dropdown
                            class="dropdowns setting-value setting-dropdown"
                            placeholder="{{'SELECT' | translate}}"
                            formControlName="maximumDrivingTimes"
                            [items]="maximumDrivingTimes"
                        ></app-dropdown>
                    </div>
                    <div class="d-flex">
                        <app-tooltip
                            class="ml-5 mr-3"
                            appCustomPopover
                            popoverText="WALK"
                            [compact]="true">
                            <ng-container icon>
                                <img
                                    src="/assets/images/icons/24_walking.svg"
                                    alt="{{'WALK' | translate}}"
                                >
                            </ng-container>
                        </app-tooltip>
                        <app-dropdown
                            class="dropdowns setting-value setting-dropdown"
                            placeholder="{{'SELECT' | translate}}"
                            formControlName="maximumWalkingTimes"
                            [items]="maximumWalkingTimes"
                        ></app-dropdown>
                    </div>
                    <div class="d-flex">
                        <app-tooltip
                            class="ml-5 mr-3"
                            appCustomPopover
                            popoverText="BICYCLE"
                            [compact]="true">
                            <ng-container icon>
                                <img
                                    src="/assets/images/icons/24_bicycle.svg"
                                    alt="{{'BICYCLE' | translate}}"
                                >
                            </ng-container>
                        </app-tooltip>
                        <app-dropdown
                            class="dropdowns setting-value setting-dropdown"
                            placeholder="{{'SELECT' | translate}}"
                            formControlName="maximumBikingTimes"
                            [items]="maximumBikingTimes"
                        ></app-dropdown>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (prioritizePatientTasksFeature) {
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="SETTINGS_PRIORITIZE_PATIENT_TASKS"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="PRIORITIZE_PATIENT_TASKS_TOOLTIP"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-toggle id=prioritizePatientTasks [large]="true" formControlName="prioritizePatientTasks"
                            (change)="prioritizePatientTasksChange()"></app-toggle>
            </div>
        </div>
    }
</form>
